import { render, staticRenderFns } from "./ProcesoDePreseleccion.vue?vue&type=template&id=89e85e54&scoped=true"
import script from "./ProcesoDePreseleccion.vue?vue&type=script&lang=js"
export * from "./ProcesoDePreseleccion.vue?vue&type=script&lang=js"
import style0 from "./ProcesoDePreseleccion.vue?vue&type=style&index=0&id=89e85e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e85e54",
  null
  
)

export default component.exports